// extracted by mini-css-extract-plugin
export var col = "SellHeader-module--col--GXPm5";
export var colFeatImg = "SellHeader-module--col-feat-img--UqbjT";
export var container = "SellHeader-module--container--AhW7s";
export var description = "SellHeader-module--description--5bcf8";
export var headline = "SellHeader-module--headline--3t8uK";
export var innerWrapper = "SellHeader-module--inner-wrapper--D0VBl";
export var promoContent = "SellHeader-module--promo-content--PkwoC";
export var subheadline = "SellHeader-module--subheadline--d63ao";
export var wrapper = "SellHeader-module--wrapper--2MYzs";